import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-card-details-delete-dialog',
    template: require('./cardDetailsDialogDelete.html')
})
export class CardDetailsDeleteDialog {

    constructor(@Inject(MatDialogRef<CardDetailsDeleteDialog>) public dialogRef: MatDialogRef<CardDetailsDeleteDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
